import React, { useState, useEffect } from 'react';
import lists from "../helpers/lists"; // Make sure lists.js exists
import { useNavigate } from "react-router-dom";

function ListItem(props) {
    return ( <li className="list-item" onClick={() => props.nav(props.route)}>
            {props.img && <img src={`./img/levels/${props.img}.png`} alt={props.header} />} {/* Check if img exists*/}
            <h3>{props.header}</h3>
            <p>{props.text}</p>
        </li>);
}

export default function Lists() {
    const navigate = useNavigate();
    const [listItems, setListItems] = useState([]);

    useEffect(() => {
        setListItems(lists);
    }, []);

    return (
        <main>
            <ul className="container lists-list">
                {listItems.map((e, index) => (
                    <ListItem
                        key={index}
                        header={e.header}
                        img={e.img}
                        text={e.text}
                        route={e.route}
                        nav={navigate}
                    />
                ))}
            </ul>
        </main>
    );
}